<template>
    <div>
        <a href="#" @click="popup = true" v-if="type == 'link'">How it works?</a>
        <b-button v-if="type == 'button'" @click="popup = true">How it works?</b-button>
        <main-dialog title="How it works?" v-model="popup" ok-only>
            <slot></slot>
        </main-dialog>
    </div>
</template>

<script>
export default {
    name: "HowItWorksPopup",
    props: {
        type: {
            type: String,
            default: 'link'
        }
    },
    data: function() {
        return {
            popup: false
        }
    },
    computed: {}
}
</script>